import HistorialVentas from './HistorialVentas';
export default HistorialVentas;